module.exports = __webpack_public_path__ + "static/media/office5.2f540f87.jpg";